import { signal } from '@preact/signals';

export interface ConfigStoreProps {
    statusBackend: string | undefined;
    titlePrefix: string;
    legal: {
        terms: number;
        privacy: number;
    };
}

export default function createConfigStore(props: ConfigStoreProps) {
    const { statusBackend, titlePrefix, legal }: ConfigStoreProps = props;

    return {
        statusBackend: signal(statusBackend),
        titlePrefix: signal(titlePrefix),
        legal: {
            terms: signal(legal.terms),
            privacy: signal(legal.privacy),
        },
    };
}
